import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Component({
  selector: 'app-calendar-dropdown',
  templateUrl: './calendar-dropdown.component.html',
  styleUrl: './calendar-dropdown.component.scss'
})
export class CalendarDropdownComponent {
  //@Input() set date(value: string | Date | null) {
  //  this.setSelectedDate(value);
  //}
  @Input() selectedDate: string | Date | null = null; // Holds the selected date
  @Output() selectedDateChange = new EventEmitter<string>(); // Emits the selected date change

  public dropdownOpen: boolean = false; // Toggles the dropdown visibility
  public days: Array<number> = []; // List of days to render
  public months: Array<string> = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  public years: Array<number> = []; // List of years to render
  public currentMonth: number = new Date().getMonth(); // Current month
  public currentYear: number = new Date().getFullYear(); // Current year
  private ignoreCloseEvent = false; // Prevent immediate close after opening
  constructor(private cdr: ChangeDetectorRef) { }


  ngOnInit(): void {
    if (this.selectedDate) {
      this.setSelectedDate(this.selectedDate);
    }
    this.populateDays();
    this.populateYears();
  }

  private setSelectedDate(value: string | Date | null): void {
    if (typeof value === 'string') {
      const parsedDate = new Date(value);
      this.selectedDate = isNaN(parsedDate.getTime()) ? null : parsedDate;
    } else if (value instanceof Date) {
      this.selectedDate = value;
    } else {
      this.selectedDate = null;
    }

    if (this.selectedDate) {
      this.currentMonth = this.selectedDate.getMonth();
      this.currentYear = this.selectedDate.getFullYear();
    }
  }

  toggleDropdown(event: Event): void {
    event.stopPropagation(); // Prevent document:click from firing
    this.ignoreCloseEvent = true; // Ignore the next document click event
    this.dropdownOpen = !this.dropdownOpen;

    if (this.dropdownOpen) {
      this.populateDays(); // Refresh days when opening
    }

    this.cdr.detectChanges();

    // Reset ignore flag after a short delay
    setTimeout(() => (this.ignoreCloseEvent = false), 200);
  }

  closeDropdown(): void {
    this.dropdownOpen = false;
    this.cdr.detectChanges();
  }

  populateDays(): void {
    const daysInMonth = new Date(this.currentYear, this.currentMonth + 1, 0).getDate();
    this.days = Array.from({ length: daysInMonth }, (_, i) => i + 1);
  }

  populateYears(): void {
    const startYear = this.currentYear - 10;
    const endYear = this.currentYear + 10;
    this.years = Array.from({ length: endYear - startYear + 1 }, (_, i) => startYear + i);
  }

  changeMonth(increment: number, event: Event): void {
    event.stopPropagation(); // Prevent closing the dropdown when navigating months
    this.currentMonth += increment;

    if (this.currentMonth < 0) {
      this.currentMonth = 11;
      this.currentYear--;
    } else if (this.currentMonth > 11) {
      this.currentMonth = 0;
      this.currentYear++;
    }

    this.populateDays(); // Refresh the days based on the updated month and year
  }

  selectDate(day: number, event: Event): void {
    event.stopPropagation();

    const date = new Date(this.currentYear, this.currentMonth, day);
    this.selectedDate = date;
    this.selectedDateChange.emit(this.formatDate(date));
    this.dropdownOpen = false;
    this.cdr.detectChanges();
  }

  getFormattedDate(): string {
    if (this.selectedDate instanceof Date) {
      return this.formatDate(this.selectedDate);
    }
    return this.selectedDate || '';
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  @HostListener('document:click')
  handleDocumentClick(): void {
    if (!this.ignoreCloseEvent) {
      this.closeDropdown();
    }
  }
}
